<div class="px-5" *transloco="let t">

    @if(!currentCategory) {
    <div class="pt-5">
        <div class="font-bold text-primary text-[32px] pb-5">{{t('chooseCategory')}}</div>
        <div class="flex gap-5 gap-y-5 flex-wrap">
            @for (category of categories; track $index) {
            <div (click)="currentCategory = category; getCompanyProducts()"
                class="h-[300px] relative w-[300px] cursor-pointer shadow-xl border-black p-2 border-2 rounded-lg"
                style="background-size:cover; background-position: center"
                [style.background-image]="'url(' + baseUrl +'/uploads/'+ category.image + ')'">
                <div class="font-semibold text-[18px] absolute categoryname">
                    {{category.name}}
                </div>
            </div>
            }
        </div>
    </div>
    }

    @if(currentCategory) {
    <div class="md:flex gap-5 pt-5">

        <div
            class="flex gap-5 overflow-x-scroll md:overflow-x-hidden w-[calc(100vw-40px)] md:w-[300px] custom-scroll md:block">
            @for (category of categories; track category.id) {
            <div (click)="currentCategory = category; getCompanyProducts()"
                class="group mb-3 min-w-[250px] w-[260px] cursor-pointer rounded-2xl border border-gray-200 bg-white px-5 py-2 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-blue-500 hover:shadow-lg"
                [ngClass]="{'!border-blue-600 bg-blue-50 shadow-md': currentCategory.id === category.id}">
                <div class="text-[14px] font-medium text-gray-800 transition-colors duration-300"
                    [ngClass]="{'text-blue-600 font-semibold': currentCategory.id === category.id}">
                    {{ category.name }}
                </div>
                <div class="mt-2 h-1 w-0 rounded-full bg-blue-600 transition-all duration-300 group-hover:w-12"
                    [ngClass]="{'!w-16': currentCategory.id === category.id}">
                </div>
            </div>
            }
        </div>

        <div class="w-full pt-5 md:pt-0 md:w-[calc(100vw-320px)]">
            <div class="font-semibold hidden md:block text-[24px] text-primary">Aziende</div>

            <div
                class="pb-5 flex flex-wrap gap-5 custom-scroll max-h-[calc(100vh-250px)] overflow-y-scroll w-[calc(100vw-40px)] md:w-full custom-scrollbar">

                @for (item of productsCompany; track $index) {
                <div (click)="myItem = item; showModalInfo = true"
                    class="w-full md:w-[600px] overflow-hidden h-fit mt-5 p-2.5 rounded-[6px] bg-Swhite shadow-xl cursor-pointer">
                    <div class="md:flex gap-5 flex-wrap">
                        @if(item.logo && item.logo != 'null') {
                        <img class="size-[200px] rounded-md object-contain bg-white"
                            [src]="baseUrl+'/uploads/'+item.logo">
                        } @else {
                        <div
                            class="size-[200px] rounded-md bg-gray-100 flex items-center justify-center border border-gray-200">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-gray-400" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                        </div>
                        }

                        <div class="w-full md:w-[calc(100%-220px)]">
                            <div class="opacity-50 w-full">
                                <div class="text-font22px text-quaternary whitespace-nowrap text-ellipsis overflow-hidden"
                                    [title]="item.name">{{item?.name}}</div>

                                <div class="text-font18px text-quaternary">
                                    @for (category of item?.categories; track $index) {
                                    {{category.name}}{{($index + 1) < item?.categories.length ? ' | ' : '' }} } </div>

                                        @if(item.website && item.website != 'null'){
                                        <div class="text-font18px text-quaternary">Sito web: {{item.website}}</div>
                                        }
                                </div>

                                <div class="flex w-full mt-2">
                                    <div style="overflow-wrap: break-word !important;"
                                        class="w-[550px] whitespace-break-spaces overflow-hidden line-clamp-3">
                                        {{item.description}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    @if(productsCompany.length == 0) {
                    <div
                        class="flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-300 bg-gray-50 py-12 px-6 text-center shadow-sm w-full">
                        <div class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3 7h18M5 7v11a2 2 0 002 2h10a2 2 0 002-2V7M9 11h6" />
                            </svg>
                        </div>
                        <h3 class="text-lg font-semibold text-gray-800">Nessuna azienda trovata</h3>
                        <p class="mt-2 max-w-md text-sm text-gray-500">
                            Al momento non sono presenti aziende per la categoria selezionata.
                            Prova a scegliere un'altra categoria.
                        </p>
                    </div>
                    }

                    <br>
                </div>
            </div>
        </div>
        }

        <std-modal class="sub-div-z z-20" [show]="showModalInfo" (close)="showModalInfo = false" [closeOnOutside]="true">
            <div header class="text-[24px] font-semibold text-Swhite text-center w-full">Dettagli Azienda</div>
            <div content class="p-4 md:p-6 bg-white rounded-b-lg flex flex-col items-center">

                @if(myItem?.logo && myItem?.logo != 'null') {
                <img class="max-h-[300px] max-w-full object-contain rounded-xl shadow-md mb-6 bg-white"
                    [src]="baseUrl+'/uploads/'+myItem.logo" [alt]="myItem?.name">
                }

                <div class="text-center w-full border-b border-gray-200 pb-4 mb-4">
                    @if(myItem?.type) {
                    <div class="mb-3">
                        <span class="bg-purple-100 text-purple-800 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                            @if(myItem.type == 1) { Azienda }
                            @else if(myItem.type == 2) { Servizio }
                            @else if(myItem.type == 3) { Consulenza }
                            @else { {{myItem.type}} }
                        </span>
                    </div>
                    }

                    <h2 class="text-3xl font-bold text-primary mb-3">{{ myItem?.name }}</h2>

                    <div class="flex flex-wrap justify-center gap-2">
                        @for (category of myItem?.categories; track $index) {
                        <span class="bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full">
                            {{category.name}}
                        </span>
                        }
                    </div>
                </div>

                <div class="flex flex-wrap items-center justify-center gap-4 mb-6 w-full">
                    @if(myItem?.website && myItem?.website != 'null') {
                    <a [href]="formatWebsite(myItem.website)" target="_blank"
                        class="text-lg text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                        </svg>
                        Sito web
                    </a>
                    }

                    <div class="w-fit h-fit">
                        <std-button (click)="$event.stopPropagation(); myItem; showModalRequest = true" size="sm"
                            buttonClass="bg-primary text-white rounded-full font-medium px-6 py-2 transition-transform hover:scale-105">
                            Crea richiesta
                        </std-button>
                    </div>
                </div>

                @if(myItem?.description && myItem?.description != 'null') {
                <div class="w-full text-justify text-gray-700 text-lg leading-relaxed whitespace-pre-wrap bg-gray-50 p-5 rounded-xl border border-gray-100 mb-4">
                    {{ myItem?.description }}
                </div>
                }

                <div class="w-full text-left bg-white p-5 rounded-xl border border-gray-200 shadow-sm mb-2">
                    <h3 class="font-bold text-primary mb-2 text-xl">Descrizione Business</h3>
                    <div class="text-justify text-gray-700 text-lg leading-relaxed whitespace-pre-wrap">
                        {{ (myItem?.businessDescription && myItem?.businessDescription != 'null') ? myItem?.businessDescription : 'Non specificato' }}
                    </div>
                </div>

                <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 text-left">

                    <div class="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                        <h3 class="font-bold text-primary mb-1 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                            </svg>
                            Specializzazioni
                        </h3>
                        <p class="text-gray-700 whitespace-pre-wrap text-sm">
                            {{ (myItem?.specializations && myItem?.specializations != 'null') ? myItem?.specializations : 'Non specificato' }}
                        </p>
                    </div>

                    <div class="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                        <h3 class="font-bold text-primary mb-1 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Certificazioni
                        </h3>
                        <p class="text-gray-700 whitespace-pre-wrap text-sm">
                            {{ (myItem?.certifications && myItem?.certifications != 'null') ? myItem?.certifications : 'Non specificato' }}
                        </p>
                    </div>

                    <div class="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                        <h3 class="font-bold text-primary mb-1 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            Referenze
                        </h3>
                        <p class="text-gray-700 whitespace-pre-wrap text-sm">
                            {{ (myItem?.references && myItem?.references != 'null') ? myItem?.references : 'Non specificato' }}
                        </p>
                    </div>

                    <div class="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                        <h3 class="font-bold text-primary mb-1 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            eProcurement
                        </h3>
                        <p class="text-gray-700 whitespace-pre-wrap text-sm">
                            {{ (myItem?.eProcurement && myItem?.eProcurement != 'null') ? myItem?.eProcurement : 'Non specificato' }}
                        </p>
                    </div>

                </div>
            </div>
        </std-modal>

        <std-modal class="sub-div-z z-30" [show]="showModalRequest" (close)="showModalRequest = false"
            [closeOnOutside]="false">
            <div header class="text-[24px] font-semibold text-Swhite">Crea richiesta</div>
            <div content>
                <div header class="text-font18px text-primary mb-5">
                    Scrivi l'oggetto e la descrizione dell'email che verrà inviata
                </div>
                <std-input [(ngModel)]="subjectEmail" customInputClass="custom-input" customLabel="label-input"
                    class="w-full mt-3" labelPosition="top" [label]="'Oggetto'" [placeholder]="'Oggetto'"></std-input>
                <std-input [(ngModel)]="descriptionEmail" type="textarea"
                    customInputClass="custom-input-text-area !max-h-auto !h-auto" customLabel="label-input mt-2"
                    class="w-full" labelPosition="top" [label]="'Descrizione'"
                    [placeholder]="'Descrizione'"></std-input>
                <std-button (click)="join(myItem)" id="button-login" size="sm"
                    buttonClass="bg-quaternary mt-5 rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[50px] transition-transform hover:scale-105">
                    Invia email richiesta
                </std-button>
            </div>
        </std-modal>

    </div>